// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import getColor from "@insite/mobius/utilities/getColor";
import { searchWithinStyles } from "@sc/Overrides/Widgets/ProductList/ProductListSearchWithin";
import Search from "@sc/XDL/Icons/Search";
import { color } from "@sc/XDL/Utilities";
import { css } from "styled-components";

searchWithinStyles.wrapper = {
    css: css`
        border: 1px solid ${color("common.border")};
        border-radius: 4px;
        overflow: hidden;
    `,
};

searchWithinStyles.searchWrapper = {
    css: css`
        padding: 0px 11px 0;
    `,
};

searchWithinStyles.titleText = {
    size: 12,
    weight: "bold",
    lineHeight: "13px",
    css: css`
        margin-bottom: 8px;
        display: inline-block;
    `,
};

searchWithinStyles.searchTextField = {
    iconProps: { src: Search, color: "common.ui8" },
    sizeVariant: "default",
    cssOverrides: {
        formField: css`
            width: 100%;
        `,
    },
};

searchWithinStyles.stockedFilterWrapper = {
    css: css`
        margin: 12px 10px 6px;
        padding-top: 11px;
        border-top: 1px solid ${getColor("common.border")};

        > div {
            &:empty {
                display: none;
            }
        }
    `,
};
